
import VictoriaHero from './components/VictoriaHero';
import VictoriaOverview from './components/VictoriaOverview';
import VictoriaLicensing from './components/VictoriaLicensing';
import VictoriaZoning from './components/VictoriaZoning';
import VictoriaMarket from './components/VictoriaMarket';
import { VictoriaEnforcement } from './components/VictoriaEnforcement';
import VictoriaCTA from './components/VictoriaCTA';
import { Navbar } from '../home/components/Navbar';
import { Footer } from '../home/components/Footer';

export default function VictoriaSTRPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <VictoriaHero />
        <VictoriaOverview />
        <VictoriaLicensing />
        <VictoriaZoning />
        <VictoriaMarket />
        <VictoriaEnforcement />
        <VictoriaCTA />
      </main>
      <Footer />
    </div>
  );
}
